import type { IProjectMemberRemovedNotificationData } from "@frontend-shared/types";
import { UserMinus } from "lucide-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { NotificationCardShell } from "../NotificationCardShell";

interface IProjectMemberRemovedCardProps {
  uuid: string;
  data: IProjectMemberRemovedNotificationData;
  createdAt: string;
  isRead: boolean;
}

const ProjectMemberRemovedCardComponent = ({
  uuid,
  data,
  createdAt,
  isRead,
}: IProjectMemberRemovedCardProps): React.JSX.Element => {
  const { t } = useTranslation("notifications");

  return (
    <NotificationCardShell
      uuid={uuid}
      variantTestId="project_member_removed"
      createdAt={createdAt}
      isRead={isRead}
      icon={<UserMinus className="h-5 w-5 text-destructive" />}
      iconBgClassName="bg-destructive/10"
      body={t("type.project_member_removed.body", {
        removedByName: data.removedByName,
        projectTitle: data.projectTitle,
      })}
    />
  );
};

export const ProjectMemberRemovedCard = memo(ProjectMemberRemovedCardComponent);
